import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

const ora = () => new Date().toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });

export function BarraSalvato() {
  const [t, setT] = useState(null);
  useEffect(() => {
    let h;
    const on = (e) => { if (!e.detail?.barra) return; setT(ora()); clearTimeout(h); h = setTimeout(() => setT(null), 3000); };
    window.addEventListener("crm:salvato", on);
    return () => { window.removeEventListener("crm:salvato", on); clearTimeout(h); };
  }, []);
  if (!t) return null;
  return createPortal(
    <div data-testid="barra-salvato" className="fixed inset-x-0 bottom-0 z-[46] bg-emerald-600 text-white px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_24px_rgba(0,0,0,0.12)]">
      <div className="max-w-4xl mx-auto lg:pl-64 flex items-center gap-2 text-sm font-semibold"><CheckCircle2 size={18} /> Modifiche salvate · {t}</div>
    </div>,
    document.body
  );
}

const quandoIt = (iso) => {
  const d = new Date(iso);
  const oggi = new Date();
  const ieri = new Date(Date.now() - 86400000);
  const h = d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
  if (d.toDateString() === oggi.toDateString()) return `oggi alle ${h}`;
  if (d.toDateString() === ieri.toDateString()) return `ieri alle ${h}`;
  return `il ${d.toLocaleDateString("it-IT")} alle ${h}`;
};

export function UltimoSalvataggio({ id, className = "" }) {
  const [u, setU] = useState(null);
  useEffect(() => {
    if (!id) return undefined;
    const load = () => api.get(`/ultimo-salvataggio/${id}`).then((r) => setU(r.data)).catch(() => {});
    load();
    const on = () => setTimeout(load, 400);
    window.addEventListener("crm:salvato", on);
    return () => window.removeEventListener("crm:salvato", on);
  }, [id]);
  if (!u?.at) return null;
  return <div data-testid="ultimo-salvataggio" className={`text-xs ${className}`}>Ultimo salvataggio: {quandoIt(u.at)}{u.by ? ` da ${u.by}` : ""}</div>;
}
